import React, { useEffect, useState } from "react";
import { Check, ShoppingCart, X, Package } from "lucide-react";

// Mini-drawer "Adicionado ao carrinho" estilo Mercado Livre. Desliza do
// topo quando um item entra no carrinho, mostra produto + dois CTAs
// (Ver carrinho / Continuar). Auto-fecha em 5s se ignorado. Substitui
// o toast efemero antigo - cliente passava reto sem perceber que tinha
// que ir pro carrinho concluir.

export const MiniDrawerCarrinho = ({ item, onFechar, onIrCarrinho }) => {
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    if (!item) return;
    // Frame seguinte pra ativar a transicao slide
    requestAnimationFrame(() => setVisivel(true));
    const t = setTimeout(() => {
      setVisivel(false);
      setTimeout(() => onFechar?.(), 250);
    }, 5500);
    return () => clearTimeout(t);
  }, [item, onFechar]);

  if (!item) return null;

  const fechar = () => {
    setVisivel(false);
    setTimeout(() => onFechar?.(), 250);
  };

  const irCarrinho = () => {
    // Navega IMEDIATAMENTE. Antes esperava 200ms num setTimeout: se o
    // auto-fechar (5,5s) ou um re-render desmontasse o drawer nesse meio,
    // o callback morria e o clique "não dava nada" (bug do dono, 29/07).
    setVisivel(false);
    onIrCarrinho?.();
  };

  return (
    // pt considera a area segura do topo: no app instalado o card de "ir pro
    // carrinho" nascia embaixo do relogio/bateria do celular (dono, 05/08).
    <div className="fixed inset-x-0 top-0 z-[90] flex justify-center pointer-events-none px-3"
      style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 0.75rem)' }}>
      <div
        className={`pointer-events-auto w-full max-w-md bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden transition-all duration-250 ${
          visivel ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-6'
        }`}
      >
        {/* Header */}
        <div className="bg-emerald-50 px-4 py-2.5 flex items-center gap-2 border-b border-emerald-100">
          <div className="w-6 h-6 rounded-full bg-emerald-600 flex items-center justify-center flex-shrink-0">
            <Check size={14} className="text-white" strokeWidth={3} />
          </div>
          <p className="text-xs font-bold text-emerald-800 flex-1">Adicionado ao carrinho</p>
          <button onClick={fechar} className="w-6 h-6 rounded-full hover:bg-emerald-100 flex items-center justify-center text-emerald-700">
            <X size={14} />
          </button>
        </div>

        {/* Item */}
        <div className="px-4 py-3 flex items-center gap-3 border-b border-slate-100">
          <div className="w-14 h-14 rounded-lg bg-slate-50 overflow-hidden flex items-center justify-center flex-shrink-0">
            {(item.foto || item.img || item.foto_url) ? (
              <img
                src={item.foto || item.img || item.foto_url}
                alt={item.nome || 'Equipamento'}
                className="w-full h-full object-cover"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            ) : (
              <Package size={22} className="text-slate-300" strokeWidth={1.5} />
            )}
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-bold text-sm text-[#12192a] truncate">{item.nome || 'Equipamento'}</p>
            <p className="text-[11px] text-slate-500">
              {item.quantidade > 1 && `${item.quantidade}x · `}
              {item.dias || 1} dia{(item.dias || 1) > 1 ? 's' : ''}
            </p>
          </div>
        </div>

        {/* CTAs */}
        <div className="px-3 py-3 flex gap-2">
          <button
            onClick={fechar}
            className="flex-1 py-2.5 rounded-xl border border-slate-200 text-xs font-bold text-slate-700 hover:bg-slate-50"
          >
            Continuar comprando
          </button>
          <button
            onClick={irCarrinho}
            className="flex-1 py-2.5 rounded-xl bg-slate-900 hover:bg-slate-800 text-white text-xs font-bold flex items-center justify-center gap-1.5"
          >
            <ShoppingCart size={14} />
            Ir pro carrinho
          </button>
        </div>
      </div>
    </div>
  );
};
